var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "" } },
        [
          _c(
            "v-layout",
            { attrs: { "justify-space-between": "" } },
            [
              !_vm.$store.getters.activeOrganization
                ? _c(
                    "v-flex",
                    { attrs: { sm6: "", md3: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.tenants,
                          label: _vm.$t("selectOrganization"),
                          "item-text": "tenantName",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.tenantSelected,
                          callback: function($$v) {
                            _vm.tenantSelected = $$v
                          },
                          expression: "tenantSelected"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.activeOrganization
                ? _c(
                    "v-flex",
                    { attrs: { md7: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.warehouses,
                          label: _vm.$t("selectWarehouse"),
                          "item-text": "warehouseName",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.warehouseSelected,
                          callback: function($$v) {
                            _vm.warehouseSelected = $$v
                          },
                          expression: "warehouseSelected"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.activeOrganization &&
              _vm.selectedWarehouseLimitedInfo.key
                ? _c(
                    "v-flex",
                    { attrs: { md4: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function() {
                              return (_vm.showRatesDialog = true)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("rates")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.$store.getters.activeOrganization
            ? _c(
                "v-layout",
                { attrs: { "justify-end": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", color: "primary" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showSignupWarehouseDialog.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("signupPreferredWarehouse")))
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", color: "primary" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showAddSiteDialog.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("addOtherWarehouse")))
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c("v-data-table", {
                staticClass: "elevation-2 myDense",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.selectedWarehouseSites,
                  pagination: _vm.pagination
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.siteName))
                        ]),
                        _vm._v(" "),
                        !(
                          _vm.warehouseSelected &&
                          _vm.$store.getters.activeOrganization &&
                          _vm.$store.getters.activeOrganization ===
                            _vm.warehouseSelected.warehouseKey
                        )
                          ? _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(props.item.orgId) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.address1))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.address2))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.city))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.state))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.zip))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.phone))
                        ]),
                        _vm._v(" "),
                        _vm.warehouseSelected &&
                        _vm.warehouseSelected.warehouseKey &&
                        _vm.warehouseSelected.warehouseKey ===
                          _vm.$store.getters.activeOrganization
                          ? _c(
                              "td",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              dark: "",
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.showEditSiteDialog(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("edit")))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              dark: "",
                                              color: "primary",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteSite(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delete")))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.addAddress
        ? _c("EditAddress", {
            attrs: {
              actionFunc: _vm.addAddressSubmitted,
              isWarehouse: "",
              siteNames: _vm.siteNames
            },
            model: {
              value: _vm.addAddress,
              callback: function($$v) {
                _vm.addAddress = $$v
              },
              expression: "addAddress"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editAddress
        ? _c("EditAddress", {
            attrs: {
              address: _vm.addressInEdit,
              editMode: "",
              isWarehouse: "",
              actionFunc: _vm.editAddressSubmitted,
              siteNames: _vm.siteNames,
              checkDistribution: function() {
                return _vm.$store.dispatch(
                  "checkTenantDistribution",
                  _vm.addressInEdit
                )
              }
            },
            model: {
              value: _vm.editAddress,
              callback: function($$v) {
                _vm.editAddress = $$v
              },
              expression: "editAddress"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.signupWarehouseDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("signupWarehouseService"),
              rightButtonDisabled: _vm.rightButtonDisabled,
              rightMethod:
                _vm.type === "listed"
                  ? _vm.signupWarehouse
                  : _vm.signupWarehouseWithName,
              rightButtonText: _vm.$t("submit"),
              hasAlert: "",
              small: ""
            },
            on: {
              popupClose: function($event) {
                _vm.signupWarehouseDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { column: false },
                          model: {
                            value: _vm.type,
                            callback: function($$v) {
                              _vm.type = $$v
                            },
                            expression: "type"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: _vm.$t("direct"), value: "direct" }
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t("listedWarehouse"),
                              value: "listed"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs8: "" } },
                            [
                              _vm.type === "direct"
                                ? _c("v-text-field", {
                                    attrs: {
                                      autofocus: "",
                                      label: _vm.$t("warehouseName")
                                    },
                                    model: {
                                      value: _vm.warehouseName,
                                      callback: function($$v) {
                                        _vm.warehouseName = $$v
                                      },
                                      expression: "warehouseName"
                                    }
                                  })
                                : _c("v-select", {
                                    staticClass: "required_field",
                                    attrs: {
                                      items: _vm.warehousesForSignup,
                                      "item-text": "warehouseName",
                                      "return-object": "",
                                      label: _vm.$t("selectAPreferredProvider"),
                                      rules: [_vm.fieldIsRequired("warehouse")]
                                    },
                                    model: {
                                      value: _vm.selectedWarehouseProvider,
                                      callback: function($$v) {
                                        _vm.selectedWarehouseProvider = $$v
                                      },
                                      expression: "selectedWarehouseProvider"
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type === "listed" && _vm.requestStatusForTheSelection
                        ? _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-left": "16px" },
                                  attrs: { sm10: "" }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "siteRequestStatusForTheSelection"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm.type === "listed" &&
                          _vm.warehousesObj[
                            _vm.selectedWarehouseProvider.warehouseKey
                          ]
                        ? _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-left": "16px" },
                                  attrs: { sm10: "" }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t("warehouseProviderHasApproved")
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm.type === "listed"
                        ? _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-left": "16px" },
                                  attrs: { sm10: "" }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "warehouseProviderIsOpenToSignup"
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.signupRequests && _vm.signupRequests.length > 0
                        ? [
                            _c("v-divider", { staticClass: "mt-4" }),
                            _vm._v(" "),
                            _c("v-layout", { staticClass: "mt-2" }, [
                              _vm._v(
                                " " + _vm._s(_vm.$t("requestStatus")) + ": "
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.signupRequests, function(item) {
                              return _c(
                                "v-layout",
                                { key: item.warehouseName },
                                [
                                  _vm._v(
                                    "\n          - " +
                                      _vm._s(item.warehouseName) +
                                      ": " +
                                      _vm._s(_vm.$t("pending")) +
                                      "\n        "
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3835675941
            ),
            model: {
              value: _vm.signupWarehouseDialog,
              callback: function($$v) {
                _vm.signupWarehouseDialog = $$v
              },
              expression: "signupWarehouseDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showRatesDialog
        ? _c("WarehouseRatesPopup", {
            attrs: {
              selectedWarehouseLimitedInfo: _vm.selectedWarehouseLimitedInfo
            },
            model: {
              value: _vm.showRatesDialog,
              callback: function($$v) {
                _vm.showRatesDialog = $$v
              },
              expression: "showRatesDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-679913aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679913aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseSite.vue
// module id = null
// module chunks = 